import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { logDownPayment, logPayment, logPaymentError, logMultiplePayments } from '../services/Api';

const PortalOne = forwardRef(
  (
    {
      setIsLoading,
      setShowHomeMenu,
      setShowLoadingText,
      GoBack,
      pol,
      zip,
      env,
      email,
      GetPaymentData,
      paymentComplete,
      isDownPayment,
      amountPaid,
      paymentDate,
      confirmationNumber,
      quoteID,
      isModalReady,
      isTextToPay,
      isNotifications,
      sessionID,
      type,
      source,
    },
    ref
  ) => {
    const $ = window.$;
    async function portalOneContainer_portalOne_saveComplete(e, data) {
      const payment = await GetPaymentData(pol, zip, env);
      if (isModalReady && isTextToPay) {
        isNotifications.current = true;
        LoadNotificationsModal(payment, sessionID.current);
      }
    }

    function portalOneContainer_portalOne_unload(e, data) {
      //show loading wheel until decision is made
      setShowLoadingText(false);
      setIsLoading(false);
      GoBack({payment: !!paymentDate?.current});
    }

    function portalOneContainer_portalOne_error(e, data) {
      console.error(new Date() + ' portalOne.error.', data.Description, data.Details);
      logPaymentError(pol, type, source, data.Description, JSON.stringify(data.Details), env);
      setShowLoadingText(false);
      setIsLoading(false);
      //GoBack();
    }

    function portalOneContainer_portalOne_paymentComplete(e, data) {
      paymentComplete.current = true;
      var Device = navigator.userAgent.match(/\(([^)]+)\)/)[1];

      if (isDownPayment.current === true) {
        amountPaid.current = data.paymentAmount;
        paymentDate.current = data.transactionDate;
        confirmationNumber.current = data.transactionId;
        quoteID.current = data.clientReferenceData1;
        logDownPayment(quoteID.current, zip, data.transactionId, data.paymentAmount, data.transactionDate, env, Device);
      }
      //Length == 2, means that you're reading the object containing the transaction objects.
      //Length > 2, means that you're reading the transaction object already.
      else if (Object.keys(data).length == 2) {
        var paymentRequests = [];
        for (const transaction of data.transactions) {
          const req = {
            PolicyNumber: transaction.clientReferenceData1,
            Email: email.current,
            Source: source ?? "Payments",
            State: transaction.clientReferenceData3,
            Device: Device,
            Env: env,
            PaymentDate: transaction.transactionDate,
            ConfirmationNumber: transaction.transactionId,
            AmountPaid: transaction.paymentAmount,
          };
          paymentRequests.push(req);
        }
        logMultiplePayments(paymentRequests);
      } 
      else {
        var State = data.clientReferenceData3;
        quoteID.current = data.clientReferenceData1;
        logPayment(quoteID.current, email.current, source ?? "Payments", State, Device, env, data.transactionDate, data.transactionId, data.paymentAmount);
      }
    }

    function portalOneContainer_portalOne_load(e, data) {

    }

    useEffect(() => {
      const script = document.createElement('script');
      script.src = `https://${env === 'prod' ? '' : 'stg'}portalone.processonepayments.com/Api/Api/Cdn/GenericModalV2/assets/js/PortalOne.js`;
      script.async = true;
      document.body.appendChild(script);
      $('#portalOneContainer').on('portalOne.saveComplete', portalOneContainer_portalOne_saveComplete);
      $('#portalOneContainer').on('portalOne.unload', portalOneContainer_portalOne_unload);
      $('#portalOneContainer').on('portalOne.error', portalOneContainer_portalOne_error);
      $('#portalOneContainer').on('portalOne.paymentComplete', portalOneContainer_portalOne_paymentComplete);
      $('#portalOneContainer').on('portalOne.load', portalOneContainer_portalOne_load);
      return () => {
        document.body.removeChild(script);
        $('#portalOneContainer').off('portalOne.saveComplete', portalOneContainer_portalOne_saveComplete);
        $('#portalOneContainer').off('portalOne.unload', portalOneContainer_portalOne_unload);
        $('#portalOneContainer').off('portalOne.error', portalOneContainer_portalOne_error);
        $('#portalOneContainer').off('portalOne.paymentComplete', portalOneContainer_portalOne_paymentComplete);
        $('#portalOneContainer').on('portalOne.load', portalOneContainer_portalOne_load);
      };
    }, [env]);

    function LoadInactivePaymentModal(d, SessionID) {
      $('#portalOneContainer').portalOne();
      d.FullName = d.Fullname === null ? '' : d.FullName;
      d.FirstName = d.FirstName === null ? '' : d.FirstName;
      d.MiddleInitial = d.MiddleInitial === null ? '' : d.MiddleInitial;
      d.LastName = d.LastName === null ? '' : d.LastName;
      $('#portalOneContainer')
        .data('portalOne')
        .makePayment({
          paymentCategory: 'UserSelect',
          feeContext: 'PaymentWithFee',
          amountContext: 'EnterAmountOnly',
          billingZip: d.Zip,
          billingAddressStreet: d.Address + ' ' + d.City + ', ' + d.State,
          policyHolderName:
            d.PolState === 'PA' ? d.FullName : d.FirstName + ' ' + (d.MiddleInitial.length > 0 ? d.MiddleInitial + '. ' : '') + d.LastName,
          clientReferenceData1: pol,
          clientReferenceData3: d.PolState,
          confirmationDisplay: 'true',
          saveOption: 'Save',
          accountGroupCode: 'FallsLake',
          acknowledgmentRequired: 'true',
          acceptCreditCards: 'true',
          acceptPrepaidCards: 'true',
          sessionId: SessionID,
        });
      setIsLoading(false);
      setShowHomeMenu(false);
    }

    function LoadManagePaymentMethodsModal(d, SessionID) {
      $('#portalOneContainer').portalOne();
      $('#portalOneContainer').data('portalOne').managePaymentMethods({
        customerId: d.CustomerID,
        sessionId: SessionID,
        acceptCreditCards: 'true',
        acceptPrepaidCards: 'true',
        paymentCategory: 'UserSelect',
        loadingIndication: 'false',
      });
      setIsLoading(false);
      setShowHomeMenu(false);
    }

    function LoadNotificationsModal(d, SessionID) {
      console.log('Loading notifications modal...');
      $('#portalOneContainer').portalOne();
      const obj = {
        externalCustomerId: pol,
        userRole: 'insured',
        customerID: d.CustomerID,
        sessionId: SessionID,
      };
      $('#portalOneContainer').data('portalOne').manageNotifications(obj);
      setIsLoading(false);
      setShowHomeMenu(false);
    }

    function LoadPaymentModal(d, SessionID, Pol = '') {
      console.log('Loading payment modal...');
      $('#portalOneContainer').portalOne();
      const obj = {
        paymentCategory: (Pol === '' ? pol : Pol).substring(0, 2) === 'AP' ? 'CreditCard' : 'UserSelect',
        feeContext: 'PaymentWithFee',
        amountContext: d.Amt === '0' || d.Amt === '0.00' || d.Amt === '' ? 'AmountDueOnly' : 'SelectAmount', //'SelectAmount',
        minAmountDue: d.Amt === '0' || d.Amt === '0.00' || d.Amt === '' ? d.Bln : d.Amt,
        maxAmountDue: d.Bln,
        accountBalance: d.Bln,
        billingZip: d.Zip === '-1' ? d.PolZip : d.Zip,
        billingAddressStreet: d.Address + ' ' + d.City + ', ' + d.State,
        policyHolderName: d.PolState === 'PA' ? d.FullName : d.FirstName + ' ' + (d.MiddleInitial != null ? d.MiddleInitial + '. ' : '') + d.LastName,
        clientReferenceData1: Pol === '' ? pol : Pol,
        clientReferenceData3: d.PolState,
        confirmationDisplay: 'true',
        saveOption: 'Save',
        accountGroupCode: 'FallsLake',
        acknowledgmentRequired: 'true',
        acceptCreditCards: 'true',
        acceptPrepaidCards: 'true',
        customerId: d.CustomerID,
        email: d.Email,
        sessionId: SessionID,
        operation: 'makePayment',
      };
      $('#portalOneContainer').data('portalOne').makePayment(obj);
      setIsLoading(false);
      setShowHomeMenu(false);
    }

    useImperativeHandle(ref, () => ({
      LoadInactivePaymentModal,
      LoadManagePaymentMethodsModal,
      LoadNotificationsModal,
      LoadPaymentModal,
    }));

    return (
      <>
        <div id='portalOneContainer'></div>
      </>
    );
  }
);

export default PortalOne;
